import ThemeModal from "components/Common/ThemeModal"
import CustomerForm from "./CustomerForm"
import { useMemo, useCallback } from "react"
import { toast } from "react-toastify"
import { useCreateCustomer, useEditCustomer } from "hooks/useCustomer"
import { useFilteredVehicleOptions } from "hooks/stockFilterHook"
import { areAllIdsNumbers } from "helpers/object_helpers"

const CustomerAddEdit = ({
  modal,
  toggleModal,
  isEdit,
  editedData,
  onSuccess,
}) => {
  const {
    isLoading: optionLoading,
    raw: rawData,
    refetch: refetchOptions,
  } = useFilteredVehicleOptions()

  const customerData = rawData?.customer ?? {}

  const formOptions = useMemo(
    () => ({
      designations: customerData?.designations ?? [],
      companies: customerData?.companies ?? [],
      banks: customerData?.banks ?? [],
      branches: customerData?.branches ?? [],
      customerTypes: customerData?.customer_types ?? [],
    }),
    [customerData]
  )

  const { mutateAsync: createMutation, isPending: createLoading } =
    useCreateCustomer()
  const { mutateAsync: editMutation, isPending: editLoading } = useEditCustomer()

  const handleSubmit = useCallback(
    async (values, { resetForm }) => {
      const isOptionRefetch = areAllIdsNumbers(values)
      const action = isEdit
        ? editMutation({ id: editedData.cuid, ...values })
        : createMutation(values)

      try {
        const res = await action

        if (!isOptionRefetch) {
          refetchOptions()
        }

        toast.success(
          res?.message ?? `Customer ${isEdit ? "updated" : "created"} successfully.`
        )
        onSuccess?.(res?.data ?? null, res)
        resetForm()
        toggleModal()
      } catch (error) {
        console.error(error)
        toast.error("Failed to save Customer.")
      }
    },
    [
      isEdit,
      editedData,
      editMutation,
      createMutation,
      refetchOptions,
      onSuccess,
      toggleModal,
    ]
  )

  return (
    <ThemeModal
      isOpen={modal}
      toggle={toggleModal}
      title={isEdit ? "Edit Customer" : "Add Customer"}
    >
      <CustomerForm
        initialData={editedData}
        options={formOptions}
        onSubmit={handleSubmit}
        isEdit={isEdit}
        isLoading={optionLoading || createLoading || editLoading}
        submitButtonText={`${isEdit ? "Save Changes" : "Add Customer"}${
          createLoading || editLoading ? "..." : ""
        }`}
      />
    </ThemeModal>
  )
}

export default CustomerAddEdit
